import styled from "styled-components/macro";

import { space, zIndex } from "shared/styles/constants";

export const ToastListContainer = styled.div`
  position: fixed;
  width: fit-content;

  top: 0;
  left: 0;
  right: 0;

  margin-right: auto;
  margin-left: auto;

  margin-top: ${space.l};

  z-index: ${zIndex.toast};
`;
